import { FieldCondition } from '../../../types/forms/fields'

export const selectCoverageOption =
  (option: string | string[]): FieldCondition =>
  v => {
    if (!v?.option) return false
    if (typeof option === 'string') return v.option === option
    return option.includes(v.option)
  }
